import React from 'react';
import {styled} from 'styled-components';
import {mediaQueries, StyledProps} from '../../modules/common/styles';
import {FullTerms} from './promo-data';
import {PromoDetail, PromoDetailLine} from './promo-detail-line';

import ColoredLink from '../colored-link';

interface PromoDetailsBoxProps {
    promoDetails: PromoDetail[];
    fullTermsURL?: FullTerms;
}

const unstyledPromoDetailsBox = (
    props: PromoDetailsBoxProps & StyledProps
): JSX.Element => {
    const {promoDetails, className, fullTermsURL} = props;
    const termsUrlComponent = fullTermsURL ? (
        <ColoredLink href={fullTermsURL.url}>{fullTermsURL.title}</ColoredLink>
    ) : null;
    return (
        <div className={className}>
            {promoDetails.map((promoLineData, i) => (
                <PromoDetailLine promoDetail={promoLineData} key={i} />
            ))}
            {termsUrlComponent}
        </div>
    );
};

export const PromoDetailsBox = styled(unstyledPromoDetailsBox)`
    padding: 16px;
    border-radius: 8px;
    border: ${(props): string => `1px solid ${props.theme.colors.caballa};`};

    ${mediaQueries.greaterThan('small')`  
        width: 360px;
        padding: 16px;
    `};

    ${mediaQueries.lessThan('small')`  
        margin-left: 16px;
        margin-right: 16px;
    `};

    margin: 0px auto 40px;

    div {
        margin-bottom: 16px;
    }

    div:last-child {
        margin-bottom: 0;
        p:last-child {
            margin-bottom: 0;
        }
    }
`;
